import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-roles-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Roles</h2>

    <div mat-dialog-content>
      @if (roles.length > 0) {
        <ul style="margin:0; padding-left:18px;">
          @for (r of roles; track r) {
            <li>{{ r }}</li>
          }
        </ul>
      } @else {
        <div>No roles assigned.</div>
      }
    </div>

    <div mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
    </div>
  `,
})
export class RolesDialogComponent {
  readonly roles: string[];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    data: { roles?: string[] } | null
  ) {
    // Normalize once, template is always safe
    this.roles = data?.roles ?? [];
  }
}
